document.addEventListener("DOMContentLoaded", () => {

  const input = document.getElementById("customer-image");
  if (!input) return;

  const previewBox = document.getElementById("upload-preview");
  const fileName = document.getElementById("file-name");
  const hiddenInput = document.getElementById("cloudinary-image-url");
  const uploadButton = document.getElementById("change-image-btn");
  const error = document.getElementById("upload-error");

  let uploadedImages = [];

  // Render thumbnails
  function renderImages() {

    previewBox.innerHTML = "";

    if (uploadedImages.length === 0) {
      previewBox.style.display = "none";
      uploadButton.innerHTML = "Upload Image";
      fileName.innerHTML = "No image selected";
      return;
    }

    previewBox.style.display = "flex";

    uploadedImages.forEach((imageUrl, index) => {

      const thumbnail = document.createElement("div");

      thumbnail.style.position = "relative";
      thumbnail.style.width = "55px";
      thumbnail.style.height = "55px";
      thumbnail.style.flexShrink = "0";

      const img = document.createElement("img");

      img.src = imageUrl;

      img.style.width = "55px";
      img.style.height = "55px";
      img.style.objectFit = "cover";
      img.style.borderRadius = "8px";
      img.style.border = "1px solid #ddd";

      // Remove button
      const removeBtn = document.createElement("button");

      removeBtn.type = "button";
      removeBtn.innerHTML = "×";

      removeBtn.style.position = "absolute";
      removeBtn.style.top = "-7px";
      removeBtn.style.right = "-7px";
      removeBtn.style.width = "20px";
      removeBtn.style.height = "20px";
      removeBtn.style.padding = "0";
      removeBtn.style.border = "none";
      removeBtn.style.borderRadius = "50%";
      removeBtn.style.background = "#222";
      removeBtn.style.color = "#fff";
      removeBtn.style.fontSize = "15px";
      removeBtn.style.lineHeight = "20px";
      removeBtn.style.cursor = "pointer";
      removeBtn.style.zIndex = "5";

      removeBtn.addEventListener("click", () => {

        uploadedImages.splice(index, 1);

        hiddenInput.value = uploadedImages.join(",");

        renderImages();

        if (uploadedImages.length > 0) {
          fileName.innerHTML =
            `✅ ${uploadedImages.length} image${uploadedImages.length > 1 ? "s" : ""} uploaded`;
        }

        error.style.display = "none";

      });

      thumbnail.appendChild(img);
      thumbnail.appendChild(removeBtn);

      previewBox.appendChild(thumbnail);

    });

    uploadButton.innerHTML =
      uploadedImages.length >= 5
        ? "Maximum 5 Images"
        : "Add More Images";

  }


  // Image Upload
  input.addEventListener("change", async () => {

    const files = Array.from(input.files);

    if (!files.length) return;

    const remainingSlots = 5 - uploadedImages.length;

    if (remainingSlots <= 0) {

      fileName.innerHTML = "Maximum 5 images allowed";

      input.value = "";

      return;
    }

    // Only allow remaining number of images
    const selectedFiles = files.slice(0, remainingSlots);

    if (files.length > remainingSlots) {

      fileName.innerHTML =
        `Only ${remainingSlots} more image${remainingSlots > 1 ? "s are" : " is"} allowed`;

    } else {

      fileName.innerHTML =
        `Uploading ${selectedFiles.length} image${selectedFiles.length > 1 ? "s" : ""}...`;

    }


    for (const file of selectedFiles) {

      const formData = new FormData();

      formData.append("file", file);
      formData.append("upload_preset", "customer-upload");

      try {

        const response = await fetch(
          "https://api.cloudinary.com/v1_1/bixzgthg/image/upload",
          {
            method: "POST",
            body: formData
          }
        );

        const data = await response.json();

        if (data.secure_url) {

          uploadedImages.push(data.secure_url);

          renderImages();

        }

      } catch (e) {

        console.log("Image upload failed", e);

      }

    }


    // Save all URLs
    hiddenInput.value = uploadedImages.join(",");

    if (uploadedImages.length > 0) {

      fileName.innerHTML =
        `✅ ${uploadedImages.length} image${uploadedImages.length > 1 ? "s" : ""} uploaded`;

      error.style.display = "none";

    } else {

      fileName.innerHTML = "Upload Failed";

    }

    // Important:
    // Reset input so the same file can be selected again later
    input.value = "";

  });


  // Required Validation
  document.addEventListener("click", function(e) {

    const btn = e.target.closest('[name="add"]');

    if (!btn) return;

    if (!hiddenInput || hiddenInput.value.trim() === "") {

      e.preventDefault();
      e.stopPropagation();

      error.style.display = "block";

      input.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });

      return false;
    }

  }, true);


  // Initial render
  renderImages();

});